define([
    'edge/platform/branding/BrandingData',
    './directives/NavBarDirective',
    'customerEdge/platform/base/JsonRPCException',
    'edge/platform/widgets/pagestructure/module',
    'edge/quoteandbind/app',
    'l10nModule',
    'edge/platform/util/module',
    'edge/platform/faq/module',
    'edge/platform/facebook/module',
    'edge/platform/segmentation/module',
    './providers/module',
    '../../../node_modules/ng-device-detector/ng-device-detector.min.js',
    '../../../node_modules/ua-device-detector/ua-device-detector.min.js',
    '../../../node_modules/re-tree/re-tree.min.js',
], (BrandingData, NavBarDirective, JsonRPCException) => {
    return angular.module('portal.app', [
        'ng.deviceDetector',
        'ui.router',
        'edge.platform.widgets.pagestructure',
        'edge.platform.l10n',
        'edge.quoteandbind.app',
        'edge.platform.util',
        'edge.platform.faq',
        'edge.platform.facebook',
        'edge.platform.campaign',
        'edge.platform.segmentation',
        'portal.app.providers',
    ])
        .config(['$locationProvider', function ($locationProvider) {
            $locationProvider.hashPrefix('');
        }])
        .run(() => {
            const branding = (BrandingData.BRANDING || '').toLowerCase();
            /* eslint-disable global-require, import/no-dynamic-require */
            switch (branding) {
                case 'ford':
                    require(['../../styles/sass/ford.scss'], () => {
                    }); // eslint-disable-line global-require, import/no-dynamic-require
                    break;
                case 'hyundai':
                    require(['../../styles/sass/hyundai.scss'], () => {
                    }); // eslint-disable-line global-require, import/no-dynamic-require
                    break;
                case 'mazda': // note: there is nopartnership with Mazda anymore but we leave the code as is at the moment
                    require(['../../styles/sass/mazda.scss'], () => {
                    }); // eslint-disable-line global-require, import/no-dynamic-require
                    break;
                case 'citroen':
                case 'peugeot':
                case 'psa':
                case 'santander':
                    require(['../../styles/sass/santander.scss'], () => {
                    }); // eslint-disable-line global-require, import/no-dynamic-require
                    break;
                case 'rci':
                    require(['../../styles/sass/rci.scss'], () => {
                    }); // eslint-disable-line global-require, import/no-dynamic-require
                    break;
                case 'tcs':
                    require(['../../styles/sass/tcs.scss'], () => {
                    }); // eslint-disable-line global-require, import/no-dynamic-require
                    break;
                case 'baloisedirect':
                    require(['../../styles/sass/baloisedirect.scss'], () => {
                    }); // eslint-disable-line global-require, import/no-dynamic-require
                    break;
                case 'baloise':
                case 'leaseplan':
                case 'amag':
                    require(['../../styles/sass/baloise.scss'], () => {
                    }); // eslint-disable-line global-require, import/no-dynamic-require
                    break;
                default:
                    require(['../../styles/sass/baloise.scss'], () => {
                    }); // eslint-disable-line global-require, import/no-dynamic-require
                    break;
                /* eslint-enable global-require, import/no-dynamic-require */
            }
        })

        .run(['configBasler', 'GTMProvider', (ConfigBasler, GTMProvider) => {
            if (!ConfigBasler.isLocal) {
                if (BrandingData.BRANDING === 'tcs') {
                    GTMProvider.injectGTM(ConfigBasler.TCS_GTM_ID);
                } else {
                    GTMProvider.injectGTM(ConfigBasler.BALOISE_GTM_ID);
                }
            }
        }])

        .config(['QuestionSetServiceProvider', 'QUESTION_SETS_CONFIG', (QuestionSetServiceProvider, QUESTION_SETS_CONFIG) => {
            QuestionSetServiceProvider.addQuestionSets(QUESTION_SETS_CONFIG);
        }])

        .config(['FaqServiceProvider', 'FAQ_CONFIG', (FaqServiceProvider, FAQ_CONFIG) => {
            FaqServiceProvider.setSections(FAQ_CONFIG.sections);
        }])

        .config(['FacebookServiceProvider', 'FACEBOOK_CONFIG', 'DEBUG_MODE', (FacebookServiceProvider, FACEBOOK_CONFIG, DEBUG_MODE) => {
            FacebookServiceProvider.setDebugMode(DEBUG_MODE);
            FacebookServiceProvider.setAppId(FACEBOOK_CONFIG.appId);
            FacebookServiceProvider.setShareDialogData(FACEBOOK_CONFIG.shareDialog);
        }])

        .config(['CampaignDataServiceProvider', 'CAMPAIGN_PARAMS_CONFIG', (CampaignDataServiceProvider, CAMPAIGN_PARAMS_CONFIG) => {
            CampaignDataServiceProvider.setUrlParamsConfig(CAMPAIGN_PARAMS_CONFIG.campaign);
        }])

        .directive('gwPortalNavBar', NavBarDirective)

        //autoscroll to top of the page: http://stackoverflow.com/questions/22290570/angular-ui-router-scroll-to-top-not-to-ui-view
        .run(['$rootScope', '$anchorScroll', ($rootScope, $anchorScroll) => {
            $rootScope.$on('$stateChangeSuccess', () => {
                $anchorScroll('page');
            });
        }])

        // Back / Forward navigation bugfix
        .run(['$rootScope', 'BaslerBrowserNavigationService', ($rootScope, BaslerBrowserNavigationService) => {
            $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState) =>
                BaslerBrowserNavigationService.handleStateChange(event, toState, fromState));
        }])

        //read http://blog.loadimpact.com/blog/exception-handling-in-an-angularjs-web-application-tutorial/ and related links
        .config(['$provide', errorHandlerConfig]);

    function errorHandlerConfig($provide) {
        // eslint-disable-next-line no-extend-native
        Error.prototype.$$passToExceptionHandler = true;
        $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function ($delegate, $injector) {
            return function (exception, cause) {

                function _extractStackTrace(exceptionOriginal) { // eslint-disable-line no-underscore-dangle

                    if (exceptionOriginal instanceof Error) {
                        //frontend error
                        return exceptionOriginal.stack;
                    }

                    //backend error: let's remove exception.baseError.config.data.params (Submission obj), since we send Submission ID
                    const exceptionCopy = angular.copy(exceptionOriginal);
                    if (exceptionCopy && exceptionCopy.baseError && exceptionCopy.baseError.config && exceptionCopy.baseError.config.data) {
                        exceptionCopy.baseError.config.data.params = '...removed by script';
                    }
                    return JSON.stringify(exceptionCopy);
                }

                function _truncateStackTraceIfNeeded(stackTrace) { // eslint-disable-line no-underscore-dangle
                    if (stackTrace && stackTrace.length > 1400) {
                        return `${stackTrace.substring(0, 1400)}...truncated`;
                    }

                    return stackTrace;
                }

                /**
                 * Send error report to the server: exception, cause, session id and quote id
                 * Returns extracted quoteId
                 */
                function _extractAndSendErrorReport() { // eslint-disable-line no-underscore-dangle
                    try {
                        const exceptionJson = _truncateStackTraceIfNeeded(_extractStackTrace(exception));
                        const causeJson = JSON.stringify(cause);

                        //$injector for TransportService, StateUtils needed to avoid circular dependencies
                        const transportService = $injector.get('TransportService');
                        const stateUtils = $injector.get('StateUtils');
                        const loggingService = $injector.get('LoggingService');
                        const loggingConstants = $injector.get('BaslerLoggingConstants');

                        const submission = stateUtils && stateUtils.activeDataForState(true) && stateUtils.activeDataForState(true).model ? stateUtils.activeDataForState(true).model.value : null;
                        const quoteId = submission ? submission.quoteID : null;
                        const sessionId = submission ? submission.sessionUUID : null;

                        console.info('sending error report to server: quote/errorreporting::logException(...)');
                        transportService.send('quote', 'errorreporting', 'logException', [exceptionJson, causeJson, sessionId, quoteId].map(it => loggingService.b64EncodeUnicode(it)));
                        loggingService.logInfo(loggingConstants.CONTACTUS, new Error([exceptionJson, causeJson, sessionId, quoteId].toString()));

                        return quoteId;
                    } catch (tryCatchException) {
                        const tryCatchExceptionMsg = (tryCatchException instanceof Error) ? tryCatchException.stack : tryCatchException;
                        console.error(`json exception handling, try/catch exception: ${tryCatchExceptionMsg}`);
                    }
                }

                /**
                 * Handles exceptions in an elegant way:
                 *  - server errors (JsonRPCException)
                 *  - non-wizard errors (!exception.step)
                 *
                 *  NOTE: AngularJS before 1.6 will trigger this code for JsonRPCException, however, from 1.6 $exceptionHandler won't be triggered, only JSONservice promise rejection and
                 *  'ContactUs' redirection will need to be implemented in DefaultErrorHandlerService(...)
                 */
                if (exception instanceof JsonRPCException || !exception.step) {

                    const quoteId = _extractAndSendErrorReport();

                    //unfortunately there is nothing else to do in case of JsonRPCException

                    if (exception instanceof JsonRPCException) {
                        const qParam = quoteId ? {quoteID: quoteId} : {};
                        $injector.get('$state').go('contactUs', qParam);
                    }

                }

                $delegate(exception, cause);
            };
        }]);
    }
});



// WEBPACK FOOTER //
// ./app/js/portal/app.js